import { useRouter } from "next/router";

export const SHAB_REDIRECT_MODAL_KEY = "SHAB_REDIRECT_MODAL";

export const useRedirectModal = () => {
  const { query } = useRouter();

  return {
    isOpen: Boolean(query[SHAB_REDIRECT_MODAL_KEY]),
    redirectUrl: "/"
  };
};
